import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import BackToTop from "@/components/BackToTop";
import { SEO } from "@/components/SEO";
import { CalculadorasHub } from "./dashboard/calculadoras/CalculadorasHub";

interface PublicCalculadorasProps {
  initialCalc?: string;
}

export const PublicCalculadoras: React.FC<PublicCalculadorasProps> = ({ initialCalc }) => {
  return (
    <div className="min-h-screen flex flex-col bg-slate-50 text-slate-900">
      <SEO
        title="Calculadoras Judiciales Oficiales | Mi Asistente Legal IA"
        description="Suite oficial de liquidaciones y cuantificaciones judiciales: perjuicios por ineficacia del traslado pensional (CSJ Sala Laboral), liquidación laboral Art. 64 CST, sentencias administrativas y dosimetría penal."
        keywords="calculadora csj, perjuicios traslado pensional, perdida de oportunidad pensional, calculadora laboral, liquidacion prestacional, colombia, relatoria corte suprema"
      />
      <Header />
      <main className="flex-grow pt-4">
        <CalculadorasHub initialCalculatorId={initialCalc} />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
};

export default PublicCalculadoras;

